<template>
  <div class="banner-area">
    <div class="banner-container">
      <div class="banner-content">
        <h2 class="banner-title">
          {{ title }}
        </h2>
      </div>
    </div>
  </div>
  <!-- 主要內容區塊錨點 (位於 Banner 之下，搭配 Skip Link 與 Alt+C 快速鍵) -->
  <div id="main-content" tabindex="-1" class="main-content-anchor">
    <a
      id="accesskey-c"
      href="#accesskey-c"
      accesskey="C"
      class="accesskey-brick sr-only-focusable"
      title="主要內容區塊，快捷鍵：Alt+C"
      aria-label="主要內容區塊"
    >:::</a>
  </div>
</template>

<script setup>
import { useLayoutStore } from "@/stores/layout";

defineProps({
  title: {
    type: String,
    required: true,
  },
});

const layoutStore = useLayoutStore();
</script>

<style scoped lang="scss">
.banner-area {
  background: linear-gradient(182.03deg, #184387 1.71%, #008bcd 98.29%);
  background-size: cover;
  width: 100%;
  margin-top: v-bind("layoutStore.pageMarginTop");

  @media (max-width: 768px) {
    margin-top: v-bind('layoutStore.showAnnouncementBanner ? "160px" : "55px"');
  }
}

.banner-container {
  max-width: 1200px;
  margin: 0 auto;
  height: 200px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  overflow: hidden;
}

.banner-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  transform: none;
}

.banner-title {
  font-size: 60px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 36px;
  }

  @media (max-width: 400px) {
    font-size: 28px;
  }
}
</style>
